import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Perfil comprado de más y plata perdida', 'Presupuestos que la inflación te come antes de terminar la obra', 'Mano de obra mal calculada: trabajás 12 horas y ganás como si fueran 6', 'Clientes que comparan precio porque no ven el valor de tu trabajo'];
  return <section className="py-12 relative overflow-hidden" data-id="element-193">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-194">
        <FadeIn data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-196">
            ¿Cuántos trabajos más vas a hacer{' '}
            <span className="text-red-500" data-id="element-197">sin saber si ganás o perdés?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-198">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-8 leading-relaxed" data-id="element-199">
            Sabés soldar, fabricar e instalar. Pero calculás a ojo, comprás
            material rezando que alcance y terminás sin saber si ganaste o
            perdiste.
            <br data-id="element-200" />
            <br data-id="element-201" />
            <strong className="text-white" data-id="element-202">
              No es falta de habilidad. Es falta de un sistema.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-203">
          <ul className="space-y-6" data-id="element-204">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-205">
                <li className="flex items-start gap-4" data-id="element-206">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-207" />
                  <span className="text-lg text-gray-300" data-id="element-208">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-209">
          <div className="mt-8 text-center" data-id="element-210">
            <p className="text-2xl md:text-3xl font-heading text-gold" data-id="element-211">
              ¿Y si este fuera el último trabajo que hacés sin sistema?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}